<div>
  <div [innerHTML]="htmlData()"></div>
</div>
